export default __webpack_public_path__ + "static/media/withdrawal.59b6ff28.svg";